<template>
    <div :id="data.id" class="volunteer-card">

        <div class="volunteer-card--photo">
            <a :href="data.link?data.link:'javascript:void(0);'">
                <img :src="data.photo.src" :alt="data.photo.alt" :title="data.photo.title" alt="volunteer-photo">
            </a>
        </div>

        <div class="volunteer-card--info">
            <div class="name">
                <a :href="data.link?data.link:'javascript:void(0);'">
                    <span>{{ data.name }}</span>
                </a>
            </div>
            <div class="job">
                <span v-for="item in data.spec">{{ item }}</span>
            </div>
            <div class="registration" v-if="data.registrationDateText">
                <span>{{ data.registrationDateText }}</span>
            </div>
        </div>
        <div class="volunteer-card--rang">
            <template v-if="data.rang">
                <img v-if="data.rang !== 0&&data.rang<=3" :src="'/local/templates/main/img/icons/rang-' + data.rang + '.svg'" alt="rang">
            </template>
        </div>
        <div class="volunteer-card--bottom" v-if="data.projectsCountText">
            <div class="volunteer-card--mark">
                <svg class="icon" width="16" height="16" viewBox="0 0 16 16" fill="none"
                     xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M5.90945 7.08754C5.90945 7.62129 5.47676 8.05398 4.94301 8.05398C4.40925 8.05398 3.97656 7.62129 3.97656 7.08754C3.97656 6.55378 4.40925 6.12109 4.94301 6.12109C5.47676 6.12109 5.90945 6.55378 5.90945 7.08754Z"
                        fill="#87929D"></path>
                    <path
                        d="M11.9173 7.08754C11.9173 7.62129 11.4846 8.05398 10.9508 8.05398C10.4171 8.05398 9.98438 7.62129 9.98438 7.08754C9.98438 6.55378 10.4171 6.12109 10.9508 6.12109C11.4846 6.12109 11.9173 6.55378 11.9173 7.08754Z"
                        fill="#87929D"></path>
                    <path fill-rule="evenodd" clip-rule="evenodd"
                          d="M1.71812 8C1.71812 11.4694 4.53061 14.2819 8 14.2819C11.4694 14.2819 14.2819 11.4694 14.2819 8C14.2819 4.53061 11.4694 1.71812 8 1.71812C4.53061 1.71812 1.71812 4.53061 1.71812 8ZM8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0Z"
                          fill="#87929D"></path>
                    <path
                        d="M11.2153 9.86587C11.4349 10.0564 11.4602 10.3914 11.2467 10.5888C10.8746 10.9324 10.4495 11.2156 9.98666 11.4266C9.36376 11.7107 8.68708 11.8576 8.00247 11.8573C7.31785 11.8571 6.64127 11.7098 6.01855 11.4253C5.55584 11.214 5.1309 10.9306 4.75911 10.5866C4.54567 10.3892 4.57121 10.0542 4.79092 9.86378C5.01063 9.67335 5.34099 9.70045 5.56047 9.89115C5.82917 10.1246 6.13062 10.319 6.45604 10.4676C6.94155 10.6894 7.46904 10.8042 8.00281 10.8044C8.53657 10.8046 9.06415 10.6901 9.5498 10.4686C9.87531 10.3202 10.1769 10.126 10.4457 9.89274C10.6653 9.70218 10.9957 9.67529 11.2153 9.86587Z"
                        fill="#87929D"></path>
                </svg>
                <span>{{ userMark }}</span>
            </div>
            <div class="volunteer-card--projects">
                {{ data.projectsCountText }}
            </div>
        </div>
    </div>
</template>

<!--/local/templates/main/img/icons/rang-1.svg-->
<!--/local/templates/main/img/icons/rang-2.svg-->
<!--/local/templates/main/img/icons/rang-3.svg-->
<script>
export default {
    name: 'TopActiveVolunteersCard',

    props: ['data'],

    computed: {
        registrationDateText() {
            return `${this.data.registrationTitle} ${this.data.registrationDate}`;
        },
        userMark() {
            return `${this.data.goodMark}/12`;
        }
    }
}
</script>

<style lang="scss" scoped>
.volunteer-card {
    padding: 44px 25px 27px;
    background-color: var(--main-bg);
    border-radius: 6px;
    box-shadow: 0px 1px 1px rgb(0 0 0 / 5%), 0px 0px 40px rgb(0 0 0 / 10%);
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;

    @media(max-width: 767px) {
        min-width: 290px;
        width: 100%;
        margin: 0 auto;
        max-width: 400px;
        padding: 44px 20px 27px;
    }

    a {
        text-decoration: none;
    }

    &--photo {
        width: 100px;
        height: 100px;
        border-radius: 50%;
        overflow: hidden;
        display: flex;

        a {
            width: 100px;
            height: 100px;
        }

        img {
            width: 100px;
            height: 100px;
            object-fit: cover;
        }
    }

    &--info {
        margin-top: 21px;
        text-align: center;

        .name {
            font-family: 'Montserrat';
            font-style: normal;
            font-weight: 600;
            font-size: 18px;
            line-height: 28px;

            a {
                color: var(--c-gray-120);
            }
        }

        .job {
            font-weight: 400;
            font-size: 14px;
            line-height: 20px;
            color: var(--c-secondary-200);
        }

        .registration {
            margin-top: 6px;
            font-weight: 400;
            font-size: 12px;
            line-height: 16px;
            color: var(--c-gray-500);
            margin-bottom: 6px;
        }
    }

    &--rang {
        margin: 14px 0 15px;
        height: 50px;
        width: 50px;
        margin-top: auto;
    }

    &--bottom {
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 100%;
        //margin-top: auto;
    }

    &--mark {
        font-weight: 600;
        font-size: 14px;
        line-height: 19px;
        color: var(--c-secondary-200);
        display: flex;
        justify-content: flex-start;
        align-items: center;
        gap: 3px;
    }

    &--projects {
        font-weight: 400;
        font-size: 14px;
        line-height: 20px;
        color: var(--c-gray-500);

        span {
            font-weight: 700;
        }
    }
}
</style>